import { render, staticRenderFns } from "./bym_vip.vue?vue&type=template&id=618295af&scoped=true"
import script from "./bym_vip.vue?vue&type=script&lang=js"
export * from "./bym_vip.vue?vue&type=script&lang=js"
import style0 from "./bym_vip.vue?vue&type=style&index=0&id=618295af&prod&lang=css"
import style1 from "./bym_vip.vue?vue&type=style&index=1&id=618295af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618295af",
  null
  
)

export default component.exports